import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { ArrowRight, Calendar, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { Card } from '../components/ui/Card';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
export function ServicesPage() {
  const {
    t,
    lang
  } = useTranslation();
  const services = [{
    id: 'fillings',
    title: t('services.fillings.title'),
    description: t('services.fillings.desc'),
    image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'root-canal',
    title: t('services.rootCanal.title'),
    description: t('services.rootCanal.desc'),
    image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'crowns',
    title: t('services.crowns.title'),
    description: t('services.crowns.desc'),
    image: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'hygiene',
    title: t('services.hygiene.title'),
    description: t('services.hygiene.desc'),
    image: 'https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'whitening',
    title: t('services.whitening.title'),
    description: t('services.whitening.desc'),
    image: 'https://images.unsplash.com/photo-1606265752439-1f18756aa5fc?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'extraction',
    title: t('services.extraction.title'),
    description: t('services.extraction.desc'),
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'smile-makeover',
    title: t('services.smileMakeover.title'),
    description: t('services.smileMakeover.desc'),
    image: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&w=800&q=80'
  }, {
    id: 'cosmetic',
    title: t('services.cosmetic.title'),
    description: t('services.cosmetic.desc'),
    image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=800&q=80'
  }];
  return <Layout data-id="element-2552">
      <div className="bg-teal-900 py-16 lg:py-20 text-white" data-id="element-2553">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2554">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-2555">
            {t('servicesPage.title')}
          </h1>
          <p className="text-xl text-teal-100 max-w-2xl mx-auto" data-id="element-2556">
            {t('servicesPage.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20" data-id="element-2557">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2558">
          {services.map(service => <Card key={service.id} hover className="overflow-hidden flex flex-col h-full border-0 shadow-lg" data-id="element-2559">
              <Link to={`/${lang}/services/${service.id}`} className="block" data-id="element-2560">
                <div className="relative aspect-[4/3] overflow-hidden" data-id="element-2561">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-2562" />
                </div>
              </Link>

              <div className="p-6 flex flex-col flex-grow" data-id="element-2563">
                <Link to={`/${lang}/services/${service.id}`} data-id="element-2564">
                  <h2 className="text-xl font-bold text-gray-900 mb-3 hover:text-teal-600 transition-colors" data-id="element-2565">
                    {service.title}
                  </h2>
                </Link>
                <p className="text-gray-600 mb-6 text-sm line-clamp-2 flex-grow" data-id="element-2566">
                  {service.description}
                </p>

                <div className="flex gap-3 mt-auto" data-id="element-2567">
                  <Link to={`/${lang}/services/${service.id}`} className="flex-1" data-id="element-2568">
                    <Button variant="outline" size="sm" fullWidth data-id="element-2569">
                      {t('services.learnMore')}
                    </Button>
                  </Link>
                  <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="flex-1" data-id="element-2570">
                    <Button size="sm" fullWidth data-id="element-2571">
                      {t('nav.bookOnline')}
                    </Button>
                  </a>
                </div>
              </div>
            </Card>)}
        </div>
      </div>

      <div className="bg-gray-50 py-16 lg:py-20" data-id="element-2572">
        <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-2573">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2574">
            {t('servicesPage.readyToBook')}
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-2575">
            {t('servicesPage.readyToBookDesc')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-2576">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-2577">
              <Button size="lg" className="gap-2 w-full sm:w-auto" data-id="element-2578">
                <Calendar className="w-5 h-5" data-id="element-2579" />
                {t('servicesPage.bookOnlineNow')}
              </Button>
            </a>
            <Link to={`/${lang}/contact`} data-id="element-2580">
              <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-2581">
                {t('servicesPage.contactUs')}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>;
}